import React from 'react';
import styled from 'styled-components';
import FooterCol from './FooterCol';
import PText from './PText';

const FooterStyles = styled.div`
  padding-top: 10rem;
  background-color: var(--deep-dark);
  .container {
    /* width: 100%; */
    display: flex;
    gap: 3rem;
  }
  .footer__col1 {
    flex: 2;
  }
  .footer__col2,
  .footer__col3,
  .footer__col4 {
    flex: 1;
  }

  .footer__col1__title {
    font-size: 3.5rem;
    margin-bottom: 1rem;
  }
  .copyright {
    background-color: var(--dark-bg);
    text-align: left;
    padding: 1rem 0;
    margin-top: 5rem;
    .para {
      margin-left: 0;
    }
  }
  @media only screen and (max-width: 768px) {
    .container {
      flex-direction: column;
      gap: 0rem;
      & > div {
        margin-top: 5rem;
      }
    }
    .footer__col1 .para {
      max-width: 100%;
    }
    .copyright {
      .container {
        div {
          margin-top: 0;
        }
      }
    }
  }
`;

export default function Footer() {
  return (
    <FooterStyles>
      <div className="container">
        <div className="footer__col1">
          <h1 className="footer__col1__title"> Vihan</h1>
          <PText>
            I am a SE with experience in designing and developing systems and
            passionate about creating user-friendly and visually appealing
            systems that meet the needs of my clients.
          </PText>
        </div>
        <div className="footer__col2">
          <FooterCol
            heading="Important Links"
            links={[
              {
                title: 'Home',
                path: '/',
                type: 'Link',
              },
              {
                title: 'About',
                path: '/about',
                type: 'Link',
              },
              {
                title: 'Projects',
                path: '/projects',
                type: 'Link',
              },
              {
                title: 'Contact',
                path: '/contact',
                type: 'Link',
              },
            ]}
          />
        </div>
        <div className="footer__col3">
          <FooterCol
            heading="Contact Info"
            links={[
              {
                title: '+94773352573',
                path: 'tel:+94773352573',
              },
              {
                title: 'danulvihan@gmail.com',
                path: 'mailto:danulvihan@gmail.com',
              },
              {
                title: 'Mount Lavinia, Sri Lanka',
                path:
                  'https://www.google.com/maps/place/Dehiwala-Mount+Lavinia/@6.8365847,79.8439262,13z/data=!3m1!4b1!4m5!3m4!1s0x3ae25a8d6ec1f8c3:0x47810f3e7d084753!8m2!3d6.8301185!4d79.8800832t',
              },
            ]}
          />
        </div>
        <div className="footer__col4">
          <FooterCol
            heading="Social Links"
            links={[
              {
                title: 'Facebook',
                path: 'https://www.facebook.com/danul.hivivihan',
              },
              {
                title: 'Instagram',
                path: 'https://www.instagram.com/hivi__9/',
              },
              {
                title: 'LinkedIn',
                path: 'https://www.linkedin.com/in/danul-hivi-vihan-397124120/',
              },
            ]}
          />
        </div>
      </div>

      <div className="copyright">
        <div className="container">
          <PText>&copy; 2023 | Designed By Danul Hivi Vihan </PText>
        </div>
      </div>
    </FooterStyles>
  );
}
